const tab_sections = {
    identity: '身份與組織',
    integrations: '應用與接入',
    login_security: '登入與安全',
    permissions: '權限與資源',
    automation: '自動化與稽核',
    platform: '平台',
    overview: '概覽',
    authentication: '身份驗證',
    authorization: '授權',
    users: '用戶',
    developer: '開發者',
    tenant: '租戶',
};
export default Object.freeze(tab_sections);
